// import Joi from 'joi-browser';
import HttpService from '@pingum/api-services/HttpService';

import buildScheduleDateQuery from '../../utils/scheduleDateQuery';
import { getScheduleBillablePriceError } from '../../utils/billablePrice';

// const numberOfDaysBetweenDates = (d1, d2) => {
//   const diff = Math.abs(d1.getTime() - d2.getTime());
//   return diff / (1000 * 60 * 60 * 24);
// };

export default class ScheduleExceptionService {
  static getScheduleExceptions(startTime, endTime, tags, page, size, sort) {
    const dateQuery = buildScheduleDateQuery(startTime, endTime);
    return this.httpService.get(`?page=${page}&size=${size}${sort}&${dateQuery}&tags=${tags || []}`);
  }

  static updateScheduleException(id, request, skipInvitationNotifications = false) {
    if (!id) {
      return Promise.reject(new Error('Missing Schedule Exception ID'));
    }

    const priceError = getScheduleBillablePriceError(request);
    if (priceError) return Promise.reject(new Error(priceError));

    return new Promise((resolve, reject) => {
      this.httpService.patch(`/${id}?skipInvitationNotifications=${skipInvitationNotifications}`, request).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static deleteSchedulExceptione(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Schedule Exception ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.delete(`/${id}`).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }
}

ScheduleExceptionService.httpService = new HttpService({
  baseURL: `${typeof window !== 'undefined'
    ? env.REACT_APP_EVENT_API
    : ''}/scheduleExceptions`,
});
